import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
  AxiosError
} from 'axios'

import { ElMessage } from 'element-plus'

import qs from 'qs'

import { config } from '@/config/axios'
import router, { RouterPath } from '@/router'
import { removeAuth, TokenKey } from '@/utils/auth'

const { base_url, doc_url } = config
export const PATH_URL = base_url[import.meta.env.VITE_API_BASEPATH]
export const DOC_URL = doc_url[import.meta.env.VITE_API_BASEPATH]

// 创建axios实例
const service: AxiosInstance = axios.create({
  baseURL: PATH_URL, // api 的 base_url
  timeout: config.request_timeout // 请求超时时间
})

// request拦截器
// 文件上传/下载超时时间（10分钟）
const FILE_TIMEOUT = 600000

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (config) {
      const token = localStorage.getItem(TokenKey)
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // 文件上传（multipart/form-data）或下载（responseType: blob）自动延长超时
    const isUpload =
      (config.headers as AxiosRequestHeaders)?.['Content-Type'] === 'multipart/form-data'
    const isDownload = config.responseType === 'blob'
    if ((isUpload || isDownload) && !config.timeout) {
      config.timeout = FILE_TIMEOUT
    }
    if (
      config.method === 'post' &&
      (config.headers as AxiosRequestHeaders)['Content-Type'] ===
        'application/x-www-form-urlencoded'
    ) {
      config.data = qs.stringify(config.data)
    }
    // get参数编码
    if (config.method === 'get' && config.params) {
      let url = config.url as string
      url += '?'
      const keys = Object.keys(config.params)
      for (const key of keys) {
        if (config.params[key] !== void 0 && config.params[key] !== null) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`
        }
      }
      url = url.substring(0, url.length - 1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error: AxiosError) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  (response: AxiosResponse<Recordable>) => {
    const isBlob = response.data instanceof Blob
    if (isBlob) {
      return response
    }
    if (response.data.code === 200) {
      return response.data.data
    } else {
      const msg = response.data?.message
      if (msg) {
        ElMessage.error(msg)
      } else {
        ElMessage.error(`Error: ${response.data.statusText} ${response.data.statusText}`)
      }
      return Promise.reject(msg)
    }
  },
  (error: AxiosError) => {
    console.log('err' + error) // for debug
    if (error.response?.status === 401) {
      removeAuth()
      router.push(RouterPath.login)
    } else if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      ElMessage.error('请求超时，请检查网络连接或稍后重试')
    } else if (!error.response) {
      ElMessage.error('网络连接失败，请检查网络设置')
    } else {
      ElMessage.error(error.message)
    }
    return Promise.reject(error)
  }
)

export default service
